module.exports = __webpack_public_path__ + "static/media/retirement-object-4-0-0.29c1a4c6.png";